export const deepPurple = {
  500: 'hsla(262, 52%, 47%, 1)',
  400: 'hsla(262, 47%, 55%, 1)',
  50: 'hsla(264, 45%, 94%, 1)',
};

export type DeepPurplePalette = typeof deepPurple;
